<template>
  <v-text-field
    :model-value="modelValue"
    class="k-field k-search"
    variant="outlined"
    rounded="lg"
    density="compact"
    hide-details
    clearable
    :placeholder="placeholder"
    :aria-label="placeholder"
    prepend-inner-icon="mdi-magnify"
    @update:model-value="$emit('update:modelValue', $event || '')"
  />
</template>

<script>
export default {
  name: "KSearch",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Rechercher",
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.k-search {
  flex: 0 1 300px;
  font-size: 13px;
  --v-input-control-height: 34px;
  --v-field-padding-top: 6px;
  --v-field-padding-bottom: 6px;
}

.k-search :deep(.v-field__input) {
  min-height: 34px;
  font-size: 13px;
}

@media (max-width: 599px) {
  .k-search {
    flex-basis: 100%;
  }
}
</style>
